import {
    CHANGE_LANGUAGE
} from './types';
import i18n from '../i18next';

export const changeLanguage = (language) => {
  return (dispatch) => {
      localStorage.setItem('translationLanguage', language);
      i18n.changeLanguage(language);
      dispatch({ type: CHANGE_LANGUAGE, payload: language });
  }
};


// WEBPACK FOOTER //
// ./src/actions/LanguageActions.js